import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

class CustomModal extends Component{
    constructor(props) {
        super(props);
    }

    render(){
        const { props } = this;

        return(
            <Modal open={props.open} onClose={props.onCloseModal} closeOnOverlayClick={false} center>
            <div className="on-setting-modal">
              <h6>{props.text}</h6>
              <div className="on-setting-modal-buttons">
                {
                    !!props.showCancel &&
                    <button onClick={props.onCloseModal} >Cancel</button>
                }
                <button onClick={props.onOkModal} >OK</button>
              </div>
            </div>
          </Modal>
    )
    }
}

export default CustomModal
